// @flow
import NewMasterListModalContainer from './NewMasterListModalContainer'
export default NewMasterListModalContainer
